import { ContainerType } from 'flow/store/engine/types';

export const EDGE_RADIUS = 16;
export const EDGE_STROKE_WIDTH = 2;

export const DEFAULT_EDGE_COLOR = 'var(--cl-juicyBlue-400)';

// edge color based on container types:
export const FOCUSED_EDGE_COLOR_BY_CONTAINER_TYPE: Record<
typeof ContainerType[keyof typeof ContainerType],
string
> = {
  [ContainerType.SNIPPET]: 'var(--cl-purple-500)',
};
